import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

type Action = Actions.UpdateFieldAction & Request.SuccessAction

export const reducer = <T extends Types.ModalData>(event: Types.ReducerEvent<T>) =>
  (state: Types.State<T>, action: Action): Types.State<T> => {
  switch (action.type) {
    case Utils.resetModalConstant(event.requestEvent):
      return {
        ...state,
        data: event.initializeState(),
      }
    case Utils.closeModalConstant(event.requestEvent):
      return {
        ...state,
        isOpen: false,
      }
    case event.toggleEvent:
    case Utils.toggleModalConstant(event.requestEvent):
      if (!state.isOpen && event.resetStateOnOpen) {
        return {
          ...Constants.emptyState(event.initializeState),
          isOpen: true,
        }
      } else {
        return {
          ...state,
          isOpen: !state.isOpen,
        }
      }
    case Request.requestConstant(event.requestEvent):
    case Utils.submitModalConstant(event.requestEvent):
      return {
        ...state,
        isSubmitting: true,
      }
    case Request.errorConstant(event.requestEvent):
      return {
        ...state,
        isSubmitting: false,
        submitSuccess: false,
      }
    case Request.successConstant(event.requestEvent):
      return {
        ...state,
        isOpen: event.keepOpenOnSuccess || false,
        isSubmitting: false,
        submitSuccess: true,
      }
    case Utils.updateModalConstant(event.requestEvent):
      return {
        ...state,
        data: Object.assign(
          {},
          state.data,
          {[action.field.name]: action.field.value},
        ),
      }
    default:
     return state || Constants.emptyState(event.initializeState)
  }
}



// WEBPACK FOOTER //
// ./src/components/modal/reducer.ts